import { render, staticRenderFns } from "./Page-with-two-sidebar.vue?vue&type=template&id=1b1485a9&"
import script from "./Page-with-two-sidebar.vue?vue&type=script&lang=js&"
export * from "./Page-with-two-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports